import { CertificationOptions } from '__generated__/graphql';
import { useActiveMember } from 'hooks';

export function useCanManageCertifications() {
  return useActiveMember().position?.certifications === CertificationOptions.ManageAll;
}
